import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CommonService } from './common.service';
import { AuthenticateService } from './authenticate.service';
import { Utility } from './utility.service';

@Injectable()
export class AuthGuardService  {
  constructor(private router: Router, private commonService: CommonService, private authenticateService: AuthenticateService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return true;
    // can be set as per msal later on
    // const currentUser = this.commonService.currentUser;
    // if (currentUser && currentUser.Id > 0 && this.authenticateService.isAuthenticated(route, state)) {
    //     return true;
    // }
    // if (state.url != '/')
    //   this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    // else
    //   this.router.navigate(['/login']);
    // return false;
  }
}
